export default {"src":"/_next/static/media/stripe-info.220bb526.svg","height":21,"width":191,"blurWidth":0,"blurHeight":0};